import type { Dispatch, SetStateAction } from 'react'

import { CustomEventTypes } from '../../../types/CustomEvent'

export const sendPageview = (
	setIsGTMLoaded: Dispatch<SetStateAction<boolean>>
): void => {
	window.gtag('event', CustomEventTypes.LOAD_DATALAYER, {
		event_callback: () => {
			setIsGTMLoaded(true)
		},
	})
}
